export const CO_LOCALE = 'co'
export const MX_LOCALE = 'mx'
export const COUNTRIES_BY_COUNTRY_CODE = {
  [CO_LOCALE]: 'Colombia',
  [MX_LOCALE]: 'México'
}
